import React from "react";
import NavigationSubNavbarLink from "../shared/NavigationSubNavbarLink";
import { t } from "../../../i18n";
import { NavLink } from "react-router-dom";

const QuizzLayout = ({ children }) => {
  return (
    <div className="quiz-layout">
      <div className="quiz-layout-header">
        <h4 className="quiz-layout-header-title">Questionários</h4>
      </div>
      <nav className="quiz-layout-navigation">
        <NavLink
          exact
          to={"/quiz"}
          activeClassName="quiz-layout-navigation-item-active"
          className="quiz-layout-navigation-item"
        >
          {t("gamification2026.quiz.active")}
        </NavLink>
        <NavLink
          to={"/quiz/history"}
          activeClassName="quiz-layout-navigation-item-active"
          className="quiz-layout-navigation-item"
        >
          {t("gamification2026.quiz.history")}
        </NavLink>
      </nav>
      {children}
    </div>
  );
};

export default QuizzLayout;
